import { Box, } from "@chakra-ui/react";
import { OperationPageHeader, } from "../../components/features/OperationPage/OperationHeader";
import { OperationMainInfo, } from "../../components/features/OperationPage/OperationMainInfo";
import { PaymentList, } from "../../components/features/OperationPage/PaymentList";
import { ProductList, } from "../../components/features/OperationPage/ProductList";
import { Outlet, redirect, useParams, } from "react-router-dom";
import { PaymentCardsView, } from "../../components/features/PaymentCardsView";
import { prepareUnleashClient, unleashClient, } from "../../unleash";
import { RoutesMap, } from "../../routes.tsx";
import { useFlag, } from "@unleash/proxy-client-react";
import { useQuery, } from "@tanstack/react-query";
import { operationByIdQueryConfig, } from "../../api";

export function OperationPage() {
  const isPaymentCardsEnabled = useFlag("payments.cards",);
  const isNextPaymentsEnabled = useFlag("payments.next_payments_block",);
  const operationId = useParams().id!;
  const operation = useQuery(operationByIdQueryConfig(operationId,),);
  const isLimitOperation = Boolean(operation.data?.operation.limitId ?? false,);

  return (
    <Box py={2}>
      <OperationPageHeader />
      <OperationMainInfo />
      {isNextPaymentsEnabled && (
        <PaymentList />
      )}
      {isPaymentCardsEnabled && (operation.isSuccess && !isLimitOperation) && (
        <Box mt={6}>
          <PaymentCardsView />
        </Box>
      )}
      <ProductList />
      <Outlet />
      <Box mb={6} />
    </Box>
  );
}

OperationPage.loader = async () => {
  await prepareUnleashClient();
  if (!unleashClient.isEnabled("operations.operation_page",)) {
    return redirect(RoutesMap.index,);
  }
  return null;
};
